import { useQuery } from "react-query"
import { AxiosResponse } from "axios"
import reservationsService from "api/reservationsService"

const useGetCarWashSchedule = (
  enabled: boolean,
  VehicleBodyTypeId: number,
  WashTypeId: number,
  CarWashId: number,
) => {
  return useQuery(
    [
      "reservation-get-carWash-schedule",
      VehicleBodyTypeId,
      WashTypeId,
      CarWashId,
    ],
    async () => {
      try {
        const res: AxiosResponse<any> =
          await reservationsService.getCarWashSchedule(
            VehicleBodyTypeId,
            WashTypeId,
            CarWashId,
          )

        return res.data
      } catch (err: any) {
        return err.response
      }
    },
    { enabled },
  )
}

export default useGetCarWashSchedule
